const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const OpsUser = require("../vault/OpsUser");
const CopyLinkButton = require("./IplBlockedCopyLink");

const styles = require("./styles/IplBlockedView.css");

const ARROW_ICON = (
	<svg
		className={styles.btnIcon}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
	>
		<path
			d="M3 8h10M9 4l4 4-4 4"
			stroke="#fff"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const BOOKMARK_ICON = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
		className={styles.bookmarkIcon}
	>
		<path
			d="M3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v12l-5-2.5-5 2.5v-12Z"
			fill="var(--navy-100)"
			stroke="var(--navy-600)"
			strokeWidth="1.5"
			strokeLinejoin="round"
		/>
	</svg>
);

const REDIRECT_FROM_AOPS_VALUE = "ba";

const withRedirectFromAops = function(url) {
	const separator = url.includes("?") ? "&" : "?";
	return `${url}${separator}redirectFromAops=${REDIRECT_FROM_AOPS_VALUE}`;
};

const ENRICHMENT_SCHOOL_URL = "https://enrichment.beastclassroom.com/school";
const ENRICHMENT_ROOT_URL = "https://enrichment.beastclassroom.com";

const getEnrichmentLinks = function() {
	return [
		{label: "Student", url: ENRICHMENT_SCHOOL_URL},
		{label: "Educator", url: ENRICHMENT_ROOT_URL},
	];
};

const getCoreLinks = function() {
	return [
		{label: "Student", url: "https://core.beastclassroom.com/student"},
		{label: "Educator", url: "https://core.beastclassroom.com/teacher"},
	];
};

const isSchoolDestination = function() {
	return (
		typeof window !== "undefined" &&
		window.location.pathname.startsWith("/school")
	);
};

const getContinueUrl = function() {
	const destination = isSchoolDestination()
		? ENRICHMENT_SCHOOL_URL
		: ENRICHMENT_ROOT_URL;
	return withRedirectFromAops(destination);
};

const LinkRow = function({label, url}) {
	return (
		<tr className={styles.tableBodyRow}>
			<td className={styles.tableCell}>
				<div className={styles.linkCell}>
					<a
						className={styles.link}
						href={url}
						target="_blank"
						rel="noopener noreferrer"
					>
						{label}
					</a>
					<CopyLinkButton url={url} />
				</div>
			</td>
		</tr>
	);
};

LinkRow.propTypes = {
	label: PT.string.isRequired,
	url: PT.string.isRequired,
};

const LinksTable = function({title, formerly, links}) {
	return (
		<div className={styles.tableWrap}>
			<table className={styles.table}>
				<thead>
					<tr className={styles.tableHeadRow}>
						<th className={styles.tableHeadCell}>
							{title}
							<span className={styles.formerly}>{formerly}</span>
						</th>
					</tr>
				</thead>
				<tbody>
					{_.map(links, link => (
						<LinkRow key={link.label} label={link.label} url={link.url} />
					))}
				</tbody>
			</table>
		</div>
	);
};

LinksTable.propTypes = {
	title: PT.string.isRequired,
	formerly: PT.node.isRequired,
	links: PT.arrayOf(
		PT.shape({
			label: PT.string.isRequired,
			url: PT.string.isRequired,
		})
	).isRequired,
};

const PageChrome = function({
	children,
	isStaff,
	onStaffBypass,
	previewView,
	onPreviewViewChange,
	isStudentView,
}) {
	let viewToggle = null;
	if (isStaff && onPreviewViewChange) {
		viewToggle = (
			<div className={styles.viewToggle} role="group" aria-label="Preview view">
				<button
					type="button"
					className={
						styles.viewToggleBtn +
						(previewView === "educator" ? " " + styles.viewToggleBtnActive : "")
					}
					onClick={() => onPreviewViewChange("educator")}
				>
					Educator
				</button>
				<button
					type="button"
					className={
						styles.viewToggleBtn +
						(previewView === "student" ? " " + styles.viewToggleBtnActive : "")
					}
					onClick={() => onPreviewViewChange("student")}
				>
					Student
				</button>
			</div>
		);
	}

	const staffBypass = isStaff ? (
		<button
			type="button"
			className={styles.staffBypass}
			onClick={onStaffBypass}
		>
			Continue to Beast Academy (staff)
		</button>
	) : null;

	const pageClass =
		styles.page +
		(isStudentView ? " " + styles.pageStudent : " " + styles.pageEducator);

	if (isStudentView) {
		return (
			<div className={pageClass}>
				{isStaff && <div className={styles.staffControlsTop}>{viewToggle}</div>}
				{children}
				{isStaff && (
					<div className={styles.staffControlsBottom}>{staffBypass}</div>
				)}
			</div>
		);
	}

	return (
		<div className={pageClass}>
			<nav className={styles.nav}>
				<div className={styles.navBrand}>
					<img
						className={styles.logoImg}
						src="/assets/images/ipl/beast-classroom.svg"
						alt="Beast Classroom"
					/>
				</div>
				{viewToggle}
			</nav>
			{children}
			<footer className={styles.footer}>
				Questions? Contact us at{" "}
				<a
					className={styles.footerLink}
					href="mailto:schools@inflectionpointlearning.com"
				>
					schools@inflectionpointlearning.com
				</a>
				{staffBypass}
			</footer>
		</div>
	);
};

PageChrome.propTypes = {
	children: PT.node.isRequired,
	isStaff: PT.bool,
	onStaffBypass: PT.func,
	previewView: PT.oneOf(["educator", "student"]),
	onPreviewViewChange: PT.func,
	isStudentView: PT.bool,
};

const EducatorContent = function() {
	return (
		<main className={styles.main}>
			<div className={styles.content}>
				<div className={styles.card + " " + styles.cardEducator}>
					<div className={styles.hero}>
						<h1 className={styles.heroTitle}>
							School accounts have moved to
							<br />
							<span className={styles.heroTitleAccent}>Beast Classroom!</span>
						</h1>
					</div>
					<div className={styles.tablesSection}>
						<p className={styles.note}>
							You can update your class bookmarks using the links below.
						</p>
						<div className={styles.tablesRow}>
							<LinksTable
								title="Enrichment Users"
								formerly={
									<>
										formerly Beast Academy
										<br />
										Online
									</>
								}
								links={getEnrichmentLinks()}
							/>
							<LinksTable
								title="Core Users"
								formerly={
									<>
										formerly Beast Academy
										<br />
										Classroom
									</>
								}
								links={getCoreLinks()}
							/>
						</div>
					</div>
					<a
						className={styles.btn}
						href={getContinueUrl()}
						target="_blank"
						rel="noopener noreferrer"
					>
						Continue to Beast Classroom
						{ARROW_ICON}
					</a>
				</div>
			</div>
		</main>
	);
};

const StudentContent = function() {
	return (
		<main className={styles.main + " " + styles.mainStudent}>
			<div className={styles.card + " " + styles.cardStudent}>
				<div className={styles.content}>
					<div className={styles.hero}>
						<h1 className={styles.heroTitle}>
							Your account has moved to
							<br />
							<span className={styles.heroTitleAccent}>Beast Classroom!</span>
						</h1>
						<p className={styles.note + " " + styles.noteStudent}>
							Your teacher can help you bookmark
							{BOOKMARK_ICON}
							the new page
						</p>
					</div>
					<div className={styles.ctaWrap}>
						<a
							className={styles.btn}
							href={getContinueUrl()}
							target="_blank"
							rel="noopener noreferrer"
						>
							Let&apos;s Go!
							{ARROW_ICON}
						</a>
					</div>
				</div>
			</div>
		</main>
	);
};

const isEducatorUser = function(user) {
	return (
		_.get(user, "model.identifiesAsEducator", false) ||
		OpsUser.hasTeacherRole(user)
	);
};

module.exports = createReactClass({
	displayName: "IplBlockedView",

	propTypes: {
		user: PT.object,
		onStaffBypass: PT.func,
	},

	getInitialState: function() {
		const user = this.props.user;
		return {
			previewView: isEducatorUser(user) ? "educator" : "student",
		};
	},

	onPreviewViewChange: function(previewView) {
		this.setState({previewView});
	},

	render: function() {
		const {user, onStaffBypass} = this.props;
		const isStaff = OpsUser.isIplStaff(user);
		const showEducator = isStaff
			? this.state.previewView === "educator"
			: isEducatorUser(user);

		return (
			<PageChrome
				isStaff={isStaff}
				onStaffBypass={onStaffBypass}
				previewView={this.state.previewView}
				onPreviewViewChange={isStaff ? this.onPreviewViewChange : null}
				isStudentView={!showEducator}
			>
				{showEducator ? <EducatorContent /> : <StudentContent />}
			</PageChrome>
		);
	},
});
